// extracted by mini-css-extract-plugin
export default {"wrapper":"index-module__wrapper--nwn","header":"index-module__header--pLC","subheader":"index-module__subheader--TOI"};